import { buildProps, definePropType } from '@ll-plus/utils'

import { type HttpModel, DEFAULT_METHOD } from './'

export const bodyProps = buildProps({
  value: {
    type: definePropType<HttpModel>(Object),
    default: () => ({
      url: '',
      method: DEFAULT_METHOD,
      requestParams: [],
      headerParams: [],
      bodyParams: {
        type: 'none',
        parameters: [],
        jsonSchema: [],
        description: ''
      }
    })
  }
} as const)

export const bodyEmits = {
  'update:value': (params: HttpModel) => !!params,
  change: (params: HttpModel) => !!params
}
